var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"link-list"},_vm._l((_vm.links),function(item){
var _obj;
return _c('li',{key:item.id,staticClass:"link-list__item flex"},[_c('router-link',{staticClass:"link-list__link",attrs:{"to":{ name: _vm.routeName, params: ( _obj = {}, _obj[_vm.paramsKey] = item[_vm.paramsValue], _obj ) }}},[_vm._v(" "+_vm._s(item[_vm.textKey])+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }